/**
 * @fileoverview gRPC-Web generated client stub for authentication_endpoint
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.1
// 	protoc              v6.32.1
// source: authentication.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as authentication_pb from './authentication_pb'; // proto import: "authentication.proto"


export class AuthenticationEndpointClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorAuthenticate = new grpcWeb.MethodDescriptor(
    '/authentication_endpoint.AuthenticationEndpoint/Authenticate',
    grpcWeb.MethodType.UNARY,
    authentication_pb.AuthenticateRequest,
    authentication_pb.AuthenticateResponse,
    (request: authentication_pb.AuthenticateRequest) => {
      return request.serializeBinary();
    },
    authentication_pb.AuthenticateResponse.deserializeBinary
  );

  authenticate(
    request: authentication_pb.AuthenticateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<authentication_pb.AuthenticateResponse>;

  authenticate(
    request: authentication_pb.AuthenticateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: authentication_pb.AuthenticateResponse) => void): grpcWeb.ClientReadableStream<authentication_pb.AuthenticateResponse>;

  authenticate(
    request: authentication_pb.AuthenticateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: authentication_pb.AuthenticateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/authentication_endpoint.AuthenticationEndpoint/Authenticate',
        request,
        metadata || {},
        this.methodDescriptorAuthenticate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/authentication_endpoint.AuthenticationEndpoint/Authenticate',
    request,
    metadata || {},
    this.methodDescriptorAuthenticate);
  }

  methodDescriptorTwoFactorConfirmation = new grpcWeb.MethodDescriptor(
    '/authentication_endpoint.AuthenticationEndpoint/TwoFactorConfirmation',
    grpcWeb.MethodType.UNARY,
    authentication_pb.TwoFactorConfirmationRequest,
    authentication_pb.TwoFactorConfirmationResponse,
    (request: authentication_pb.TwoFactorConfirmationRequest) => {
      return request.serializeBinary();
    },
    authentication_pb.TwoFactorConfirmationResponse.deserializeBinary
  );

  twoFactorConfirmation(
    request: authentication_pb.TwoFactorConfirmationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<authentication_pb.TwoFactorConfirmationResponse>;

  twoFactorConfirmation(
    request: authentication_pb.TwoFactorConfirmationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: authentication_pb.TwoFactorConfirmationResponse) => void): grpcWeb.ClientReadableStream<authentication_pb.TwoFactorConfirmationResponse>;

  twoFactorConfirmation(
    request: authentication_pb.TwoFactorConfirmationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: authentication_pb.TwoFactorConfirmationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/authentication_endpoint.AuthenticationEndpoint/TwoFactorConfirmation',
        request,
        metadata || {},
        this.methodDescriptorTwoFactorConfirmation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/authentication_endpoint.AuthenticationEndpoint/TwoFactorConfirmation',
    request,
    metadata || {},
    this.methodDescriptorTwoFactorConfirmation);
  }

  methodDescriptorRefreshToken = new grpcWeb.MethodDescriptor(
    '/authentication_endpoint.AuthenticationEndpoint/RefreshToken',
    grpcWeb.MethodType.UNARY,
    authentication_pb.RefreshTokenRequest,
    authentication_pb.RefreshTokenResponse,
    (request: authentication_pb.RefreshTokenRequest) => {
      return request.serializeBinary();
    },
    authentication_pb.RefreshTokenResponse.deserializeBinary
  );

  refreshToken(
    request: authentication_pb.RefreshTokenRequest,
    metadata?: grpcWeb.Metadata | null): Promise<authentication_pb.RefreshTokenResponse>;

  refreshToken(
    request: authentication_pb.RefreshTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: authentication_pb.RefreshTokenResponse) => void): grpcWeb.ClientReadableStream<authentication_pb.RefreshTokenResponse>;

  refreshToken(
    request: authentication_pb.RefreshTokenRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: authentication_pb.RefreshTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/authentication_endpoint.AuthenticationEndpoint/RefreshToken',
        request,
        metadata || {},
        this.methodDescriptorRefreshToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/authentication_endpoint.AuthenticationEndpoint/RefreshToken',
    request,
    metadata || {},
    this.methodDescriptorRefreshToken);
  }

  methodDescriptorLogout = new grpcWeb.MethodDescriptor(
    '/authentication_endpoint.AuthenticationEndpoint/Logout',
    grpcWeb.MethodType.UNARY,
    authentication_pb.LogoutRequest,
    authentication_pb.LogoutResponse,
    (request: authentication_pb.LogoutRequest) => {
      return request.serializeBinary();
    },
    authentication_pb.LogoutResponse.deserializeBinary
  );

  logout(
    request: authentication_pb.LogoutRequest,
    metadata?: grpcWeb.Metadata | null): Promise<authentication_pb.LogoutResponse>;

  logout(
    request: authentication_pb.LogoutRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: authentication_pb.LogoutResponse) => void): grpcWeb.ClientReadableStream<authentication_pb.LogoutResponse>;

  logout(
    request: authentication_pb.LogoutRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: authentication_pb.LogoutResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/authentication_endpoint.AuthenticationEndpoint/Logout',
        request,
        metadata || {},
        this.methodDescriptorLogout,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/authentication_endpoint.AuthenticationEndpoint/Logout',
    request,
    metadata || {},
    this.methodDescriptorLogout);
  }

  methodDescriptorGetSessions = new grpcWeb.MethodDescriptor(
    '/authentication_endpoint.AuthenticationEndpoint/GetSessions',
    grpcWeb.MethodType.UNARY,
    authentication_pb.GetSessionsRequest,
    authentication_pb.GetSessionsResponse,
    (request: authentication_pb.GetSessionsRequest) => {
      return request.serializeBinary();
    },
    authentication_pb.GetSessionsResponse.deserializeBinary
  );

  getSessions(
    request: authentication_pb.GetSessionsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<authentication_pb.GetSessionsResponse>;

  getSessions(
    request: authentication_pb.GetSessionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: authentication_pb.GetSessionsResponse) => void): grpcWeb.ClientReadableStream<authentication_pb.GetSessionsResponse>;

  getSessions(
    request: authentication_pb.GetSessionsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: authentication_pb.GetSessionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/authentication_endpoint.AuthenticationEndpoint/GetSessions',
        request,
        metadata || {},
        this.methodDescriptorGetSessions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/authentication_endpoint.AuthenticationEndpoint/GetSessions',
    request,
    metadata || {},
    this.methodDescriptorGetSessions);
  }

}

